import { Typography } from "@mui/material";
import PlateWell from "features/WorklistTools/shared/components/PlateWell";
import React from "react";
import { contextMenu } from "react-contexify";
import styled from "styled-components";
import { PlatePosition, WorklistTools } from "../../shared/interfaces";
import {
  getColIndexFromSelectedWell,
  getPlateWellIdFromRowAndColIndex,
  getRowIndexFromSelectedWell,
} from "../../shared/WorklistHelpers";

interface NucleofectionPlateProps {
  worklistTool: WorklistTools;
  index: number;
  plateRows: number[];
  plateCols: number[];
  wellInfo: any[];
  wellMapping: any[];
  borderColor?: string;
  sourcePlateInfo?: any[];
  sourcePlatePosition: PlatePosition;
}

const StyledNucleofectionPlate = styled.div<{
  borderColor: string | undefined;
}>`
  height: 100%;
  width: 100%;
  padding: 15px;
  box-shadow: 0px 0 4px -1px black;
  // background-color: white;
  border-radius: 5px;
  border: ${(props) => (props.borderColor ? "3px" : "1px")} solid
    ${(props) => props.borderColor ?? "#ded7e9"};

    
`;

const StyledDestPlateElements = styled.div<{
  cols: number[];
  rows: number[];
}>`
  display: grid;
  height: 100%;
  width: 100%;
  grid-gap: 4px 4px;
  grid-template-columns: repeat(${(props) => props.cols.length + 1}, 1fr);
  grid-template-rows: repeat(${(props) => props.rows.length + 1}, 1fr);
  justify-items: center;
  align-items: center;
`;

const PlateHeaderCell = styled(Typography)<{
  rowStart: number;
  colStart: number;
}>`
  display: flex;
  grid-row-start: ${(props) => `${props.rowStart}`};
  grid-column-start: ${(props) => `${props.colStart}`};
  align-items: center;
  justify-content: center;
  height: 5px;
  width: 5px;
`;

export const NucleofectionPlate = ({
  worklistTool,
  index,
  plateRows,
  plateCols,
  wellInfo,
  wellMapping,
  borderColor,
  sourcePlateInfo,
  sourcePlatePosition,
}: NucleofectionPlateProps) => {
  const getWellColor = (row: number, col: number) => {
    const index = wellInfo.findIndex(
      (e) => e.rowPos === row + 1 && e.colPos === col + 1
    );

    if (index > -1) {
      return wellInfo[index].color;
    } else {
      const harvestWells = wellMapping.filter(
        (e) =>
          e.destPlateIndex === 0 &&
          e.destWellId === getPlateWellIdFromRowAndColIndex(row, col)
      );

      if (harvestWells.length < 1) {
        return "";
      }

      const index = sourcePlateInfo![
        harvestWells[0].sourcePlateIndex
      ].wellInfo.findIndex(
        (e: any) =>
          e.rowPos ==
            getRowIndexFromSelectedWell(harvestWells[0].sourceWellId) + 1 &&
          e.colPos ==
            getColIndexFromSelectedWell(harvestWells[0].sourceWellId) + 1
      );
      if (index === -1) return "";
      return (
        sourcePlateInfo![harvestWells[0].sourcePlateIndex].wellInfo[index]
          .color ?? ""
      );
    }
  };

  const handleContextMenu = (
    e: React.MouseEvent<HTMLDivElement>,
    menuId: string
  ) => {
    e.preventDefault();
    contextMenu.show({
      id: menuId,
      event: e,
    });
  };

  return (
    <>
      <StyledNucleofectionPlate
        onContextMenu={(e) => {
          handleContextMenu(e, `${worklistTool}_Nucleofection_${index}`);
        }}
        borderColor={borderColor}
      >
        <StyledDestPlateElements rows={plateRows} cols={plateCols}>
          <PlateHeaderCell rowStart={1} colStart={1}></PlateHeaderCell>
          {plateRows.map((row, index) => (
            <PlateHeaderCell rowStart={row + 1} colStart={1}>
              <p style={{ fontSize: "medium" }}>
                {String.fromCharCode(64 + row)}
              </p>
            </PlateHeaderCell>
          ))}
          {plateCols.map((col, index) => (
            <PlateHeaderCell rowStart={1} colStart={col + 1}>
              <p style={{ fontSize: "medium" }}>{index + 1}</p>
            </PlateHeaderCell>
          ))}
          {plateRows.map((rowItem, rowIndex) =>
            plateCols.map((colItem, colIndex) => (
              <div style={{ width: "100%", height: "100%" }}>
                <PlateWell
                  plateIndex={index}
                  platePosition={PlatePosition.Nucleofection}
                  plateWellId={
                    String.fromCharCode(65 + rowIndex) + String(colIndex + 1)
                  }
                  wellColor={getWellColor(rowIndex, colIndex)}
                ></PlateWell>
              </div>
            ))
          )}
        </StyledDestPlateElements>
      </StyledNucleofectionPlate>
    </>
  );
};
